export default {
  SHOWN_PRODUCTS: (process.env.REACT_APP_SHOWN_PRODUCTS || "").split(","),
  API_URL: process.env.REACT_APP_API_URL,
  USPS_URL: process.env.REACT_APP_USPS_URL,
  PASSPORTS_SELECT_PORTRAIT:
    process.env.REACT_APP_PASSPORTS_SELECT_PORTRAIT === "true",
  PASSPORT_GENERATE_MAX_COUNT:
    process.env.REACT_APP_PASSPORT_GENERATE_MAX_COUNT || 8,
  PASSPORT_PORTAIT_REQUEST_INTERVAL:
    process.env.REACT_APP_PASSPORT_PORTAIT_REQUEST_INTERVAL || 60, // in minutes
  FORCE_GOVFEE_UPSELL_IDS: process.env.REACT_APP_FORCE_GOVFEE_UPSELL_IDS,
  HANDLING_FEE_UPSELL_ID: process.env.REACT_APP_HANDLING_FEE_UPSELL_ID,
  HANDLING_FEE_THRESHOLD: (() => {
    const value = parseFloat(process.env.REACT_APP_HANDLING_FEE_THRESHOLD);
    return !isNaN(value) && value > 0 ? value : 130;
  })(),
};
